import { render, staticRenderFns } from "./ProcedureDocument.vue?vue&type=template&id=1c9212aa&scoped=true"
import script from "./ProcedureDocument.vue?vue&type=script&lang=js"
export * from "./ProcedureDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9212aa",
  null
  
)

export default component.exports